<!-- 量表结果 -->
<template>
  <div class="card">
    <div class="scale-result">
      <div class="title">
        <span>患者的{{ scaleResult?.scaleResultTitle || '调查问卷' }}结果</span>
        <span class="right" @click="toInfo" v-if="scaleResult?.scaleResultUrl">
          <span>详情</span>
          <RightOutlined style="margin-left: 4px" />
        </span>
      </div>
      <div class="body">
        <template v-if="scaleResult?.resultList?.length">
          <div v-for="(item, index) in scaleResult?.resultList" :key="index" class="list">
            <Results :label="item.label" :value="item.value" :conclusion="item.tips"></Results>
          </div>
        </template>
        <div class="tips" v-if="scaleResult?.thereMayBeIssues">
          {{ scaleResult.thereMayBeIssues }}
        </div>
        <template v-if="recommendDoctorInfo && recommendDoctorInfo.doctorName">
          <div class="driver">
            <auth-img src="@/assets/img/docLine.png" class="image" mode="widthFix" />
          </div>
          <div class="doc">
            <DocCard
              :name="recommendDoctorInfo?.doctorName"
              :department="recommendDoctorInfo?.department"
              :title="recommendDoctorInfo?.title"
              :hospital="recommendDoctorInfo?.hospital"
              :specialty="recommendDoctorInfo?.expertise"
              :avatar="recommendDoctorInfo?.headUrl"
            ></DocCard>
          </div>
        </template>
      </div>
    </div>
    <Info ref="infoRef" :url="scaleResult?.scaleResultUrl"></Info>
  </div>
</template>
<script setup>
import Results from './Results.vue'
import DocCard from './DocCard.vue'
import Info from './Info.vue'
import { RightOutlined } from '@ant-design/icons-vue'
import { ref, defineProps, watch } from 'vue'
const infoRef = ref(null)
const recommendDoctorInfo = ref(null)
const scaleResult = ref(null)
const props = defineProps({
  msg: {
    type: Object,
    default: () => {}
  }
})
const init = val => {
  scaleResult.value = val?.professionalWomenScaleResult
    ? JSON.parse(val?.professionalWomenScaleResult)
    : null
  recommendDoctorInfo.value = val?.recommendDoctorInfoVO
    ? JSON.parse(val?.recommendDoctorInfoVO)
    : null
}
watch(
  () => props.msg,
  val => {
    init(val)
  },
  {
    deep: true,
    immediate: true
  }
)

const toInfo = () => {
  infoRef.value.showDrawer()
}
</script>
<style lang="scss" scoped>
.card {
  display: flex;
  justify-content: center;
  align-content: center;
  .scale-result {
    position: relative;
    width: 343px;
    background: #ffffff;
    border-radius: 8px;
    overflow: hidden;
    .body {
      padding: 12px 14px 14px 14px;

      .list {
        margin-bottom: 12px;
      }
      .tips {
        font-size: 14px;
        color: #333333;
        margin-bottom: 12px;
      }
      .driver {
        width: 100%;
        margin-bottom: 12px;
        .image {
          width: 100%;
          height: 100%;
        }
      }
    }
    .title {
      display: flex;
      padding: 12px 14px;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #fafafa;
      line-height: 1.5;
      font-weight: bold;
      font-size: 16px;
      color: #333333;
    }
    .right {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      color: #999999;
      font-weight: 400;
      cursor: pointer;
    }
  }
}
</style>
